import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tag } from 'src/app/entities/tag/tag';
import { TagRepository, TimeTrackTagsFilters } from './repositories/tag-repository/tag.repository';
import { ProjectRepository, ProjectsFilters } from './repositories/project-repository/project.repository';
import { Project } from 'src/app/entities/project/project';
import { ClientRepository, ClientsFilters } from './repositories/person-repository/client.repository';
import { Client } from 'src/app/entities/client/client';
import { TimeTrack } from 'src/app/entities/time-track/time-track';
import { TimeTrackRepository, TimeTracksFilters } from './repositories/time-track-repository/time-track.repository';
import { User } from 'src/app/entities/user/user';
import { UserFilters, UserRepository } from './repositories/user-repository/user.repository';

@Injectable({
  providedIn: 'root',
})
export class RemoteDataService {
  constructor(
    protected tagRepository: TagRepository,
    protected projectRepository: ProjectRepository,
    protected clientRepository: ClientRepository,
    protected timeTrackRepository: TimeTrackRepository,
    protected userRepository: UserRepository
  ) { }

  allTags(filters?: TimeTrackTagsFilters): Observable<Tag[]> {
    return this.tagRepository.retrieveAll<TimeTrackTagsFilters>(filters);
  }

  /**
   * Get all projects from project repository.
   *
   * @returns {Observable<Project[]>}
   */
  allProjects(filters?: ProjectsFilters): Observable<Project[]> {
    return this.projectRepository.retrieveAll<ProjectsFilters>(filters);
  }

  /**
   * Get all projects from project repository.
   *
   * @returns {Observable<Client[]>}
   */
  allClients(filters?: ClientsFilters): Observable<Client[]> {
    return this.clientRepository.retrieveAll<ClientsFilters>(filters);
  }

  /**
   * Get all timetrack from project repository.
   *
   * @returns {Observable<TimeTrack[]>}
   */
  allTimeTracks(filters?: TimeTracksFilters): Observable<TimeTrack[]> {
    return this.timeTrackRepository.retrieveAll<TimeTracksFilters>(filters);
  }

  /**
   * Get the current user that is being used.
   *
   * @returns {Observable<User>}
   */
  getUsers(filters?: UserFilters): Observable<User[]> {
    return this.userRepository.retrieveAll<UserFilters>(filters);
  }
}
